


























































import PartnerReportCreateForm, {
  PartnerReportCreateFormSubmit
} from "@/components/partner/PartnerReportCreateForm.vue";
import PreselectTemplateCard from "@/components/partner/PreselectTemplateCard.vue";
import { IPartnerMessage } from "@/models/partner-message.entity";
import { IReference } from "@/models/reference.entity";
import { IReport } from "@/models/report.entity";
import { ISharedContent } from "@/models/shared-content.entity";
import { BackendResourceEnum, ResourceEnum } from "@/store/enum/authResourceEnum";
import { PartnerModule } from "@/store/modules/partner";
import { Component, Ref, Vue } from "vue-property-decorator";
import { PreselectTemplateKeysEnum } from "@/lib/enum/preselect-template-keys.enum";

enum PartnerReportCreateDialogWindow {
  FORM = "FORM",
  SEND_MAIL = "SEND_MAIL"
}

@Component({
  components: {
    PartnerReportCreateForm,
    PreselectTemplateCard
  }
})
export default class PartnerReportCreateDialog extends Vue {
  readonly PreselectTemplateKeysEnum = PreselectTemplateKeysEnum;
  readonly BackendResourceEnum = BackendResourceEnum;
  ResourceEnum = ResourceEnum;
  PartnerReportCreateDialogWindow = PartnerReportCreateDialogWindow;

  dialogOpen = false;
  window = PartnerReportCreateDialogWindow.FORM;

  sharedContent: ISharedContent | null = null;
  report: IReport | null = null;

  isSendLoading = false;

  @Ref("templateCard")
  templateCard!: PreselectTemplateCard;

  get isMobile() {
    return this.$vuetify.breakpoint.smAndDown;
  }

  get partner() {
    return PartnerModule.partner;
  }

  get to(): string[] {
    const mail = this.report?.customerContact.email;

    return mail ? [mail] : [];
  }

  get context() {
    return {
      report: this.report,
      sharedContent: this.sharedContent,
      partner: this.partner,
      url: { sharing: this.sharedContent?.url }
    };
  }

  get mailRefs(): IReference[] {
    const refs: IReference[] = [];

    if (this.report?.id) {
      refs.push({
        refType: BackendResourceEnum.REPORT,
        refId: this.report.id
      });
    }

    return refs;
  }

  setReport(report: IReport) {
    this.report = report;
  }

  setSharedContent(sharedContent: ISharedContent) {
    this.sharedContent = sharedContent;
  }

  setAttachmentRequest(attachmentRequest: any) {
    this.$log.debug(attachmentRequest);
  }

  open() {
    this.dialogOpen = true;
  }

  close() {
    if (this.window === PartnerReportCreateDialogWindow.SEND_MAIL) {
      if (this.report && this.sharedContent) {
        this.$router.push({
          name: "PartnerReportsDetailView",
          params: {
            partnerId: this.report.partnerId,
            reportId: this.report.id
          }
        });
      }
    }
    this.dialogOpen = false;
  }

  async send() {
    this.isSendLoading = true;
    await this.templateCard?.send();
    this.isSendLoading = false;
  }

  sent(message: IPartnerMessage) {
    this.$log.debug("sent");
    this.$toast.success("👍");

    if (!this.report) {
      this.close();
      return;
    }

    this.$router.push({
      name: "PartnerReportsDetailView",
      params: {
        partnerId: this.report.partnerId,
        reportId: this.report.id
      }
    });
    this.close();
  }

  submit(submit: PartnerReportCreateFormSubmit) {
    this.$log.debug(submit);

    if (submit.isNotifyUser) {
      this.window = PartnerReportCreateDialogWindow.SEND_MAIL;
    } else {
      this.$router.push({
        name: "PartnerReportsDetailView",
        params: {
          partnerId: submit.report.partnerId,
          reportId: submit.report.id
        }
      });
    }
  }
}
